import { withStyles } from '@material-ui/core';
import React from 'react';
import Modal from '@material-ui/core/Modal';

import DataList from '../DataList';
import Questions from '../Questions';

const styles = theme => ({
  preview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

class QuestionsAnalytics extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showModal: false, filteredUsers: [] };
  }

  render() {
    const { interactionStatistics, users, classes } = this.props;

    let { filter } = this.props;
    if (!filter) {
      filter = (interaction, question, entry) => {
        const filteredUsers = users.filter(user => {
          if (entry.users && entry.users.includes(user._id)) {
            return true;
          }
          return false;
        });
        this.setState({ showModal: true, filteredUsers });
      };
    }

    if (interactionStatistics) {
      const title = interactionStatistics.title;
      const data = interactionStatistics.data;

      return (
        <div>
          <DataList listUsersInteraction={users} />
          <Questions title={title} data={data} filter={filter} />
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.state.showModal}
            onClose={() => this.setState({ showModal: false })}
            className={classes.preview}
          >
            <div className={classes.containerUsersAnalyticsView}>
              <div style={{ textAlign: 'center' }}>
                <DataList listUsersInteraction={this.state.filteredUsers} />
              </div>
            </div>
          </Modal>
        </div>
      );
    }
    return null;
  }
}

export default withStyles(styles)(QuestionsAnalytics);
